import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const EXPLANATION = 'Поддержка работает в бета-режиме: отвечаем вручную, возможны задержки';

export default /*@__PURE__*/_defineComponent({
  __name: 'BetaBadge',
  setup(__props) {

/**
 * Пометка «раздел работает в бета-режиме».
 *
 * Намеренно без Vuetify и без composition API: v-tooltip не застаблен ни в
 * одной из спек поддержки (CreateTicketModal / SupportPage / SupportTicketPage),
 * и слот #activator там просто не отрисовался бы — бейдж исчезал бы из DOM в
 * тестах, оставаясь видимым в браузере.
 *
 * `title` — бонус для десктопного hover; смысл дублируется в aria-label,
 * потому что title не открывается ни по тапу, ни с клавиатуры.
 */

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: "beta-badge",
    role: "note",
    "aria-label": EXPLANATION,
    title: EXPLANATION
  }, " BETA "))
}
}

})